import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IndicadorCliente } from 'src/app/admihair/api/dto/indicador-cliente';
import { IndicadorClienteService } from 'src/app/admihair/service/indicador-cliente.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-indicador-cliente-editar',
  templateUrl: './indicador-cliente-editar.component.html',
  styleUrls: ['./indicador-cliente-editar.component.scss']
})
export class IndicadorClienteEditarComponent extends AdmihairBaseComponent implements OnInit {
  
  @ViewChild('f') form?: NgForm;
  loading: boolean = true;
  id?: number;
  indicadorCliente?: IndicadorCliente;
  progressoRequisicao: boolean = false;

  constructor(private utilStorageService: UtilStorageService,
    private indicadorClienteService: IndicadorClienteService,
    private _router: Router,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) { super(erroService, storageService) }


  ngOnInit(): void {
    this.permissaoEditar = AuthUtil.verificarPermissao('PERM_EDITAR_CANAL_DE_INDICACAO');
    if (this.permissaoEditar) {
      this.carregarIndicador();
    }
  }

  atualizar() {
    this.progressoRequisicao = true;
    this.indicadorClienteService.atualizar(this.id, this.indicadorCliente).subscribe(
      data => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      err => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err)
      }
    );
  }

  carregarIndicador() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) this.id = parseInt(idParam);
    this.indicadorClienteService.buscarPorId(this.id).subscribe(
      data => {
        this.indicadorCliente = data;
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    )
  }
}